import React from 'react';
import img1 from '../Assets/imageslider/1.png';
import img2 from '../Assets/imageslider/3.png';
import img3 from '../Assets/imageslider/4.png';
import img4 from '../Assets/imageslider/5.png';

const ImageSlider = () => {
  const images = [img1, img2, img3, img4];

  return (
    <div>
      <h3 className="mb-7 mt-4 text-3xl pt-12 pb-6 font-medium leading-tight text-gray-700 text-center text-primary p-2">
        Why plan with us?
      </h3>
      <div className="flex flex-col lg:flex-row items-center flex-wrap justify-between max-w-6xl mx-auto">
        {images.map((image, index) => (
          <div key={index} className="sm:mb-0 mb-4 p-2">
              <img
                src={image}
                alt={`img-${index + 1}`}
                className="w-full h-20 object-cover rounded-lg shadow-none transition-shadow duration-300 ease-in-out hover:shadow-lg hover:shadow-black/30"
              />
            </div>
        ))}
      </div>
    </div>
  );
};

export default ImageSlider;
